'use client';

import { c as _c } from "react/compiler-runtime";
import { InfoTooltip, type InfoTooltipProps } from '@repo/ui/composites/InfoTooltip';
import { useMonetizingTooltipPageAction } from '../DriversLegacy/hooks';
export function DriverValueTooltip(t0) {
  const $ = _c(11);
  let driverKey;
  let segmentActionSection;
  let tooltipProps;
  if ($[0] !== t0) {
    ({
      driverKey,
      segmentActionSection,
      ...tooltipProps
    } = t0);
    $[0] = t0;
    $[1] = driverKey;
    $[2] = segmentActionSection;
    $[3] = tooltipProps;
  } else {
    driverKey = $[1];
    segmentActionSection = $[2];
    tooltipProps = $[3];
  }
  const handleTooltipClickPageAction = useMonetizingTooltipPageAction();
  let t1;
  if ($[4] !== driverKey || $[5] !== handleTooltipClickPageAction || $[6] !== segmentActionSection) {
    t1 = segmentActionSection && {
      onOpen: () => handleTooltipClickPageAction(driverKey, "open", segmentActionSection),
      onClose: () => handleTooltipClickPageAction(driverKey, "close", segmentActionSection),
      onBlur: () => handleTooltipClickPageAction(driverKey, "close", segmentActionSection)
    };
    $[4] = driverKey;
    $[5] = handleTooltipClickPageAction;
    $[6] = segmentActionSection;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1 || $[9] !== tooltipProps) {
    t2 = <InfoTooltip {...tooltipProps} {...t1} />;
    $[8] = t1;
    $[9] = tooltipProps;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}